export default "__VITE_ASSET__38851f5b__"